import { render, staticRenderFns } from "./accountPlan.vue?vue&type=template&id=616c4e2c&scoped=true&"
import script from "./accountPlan.vue?vue&type=script&lang=js&"
export * from "./accountPlan.vue?vue&type=script&lang=js&"
import style0 from "./accountPlan.vue?vue&type=style&index=0&id=616c4e2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616c4e2c",
  null
  
)

export default component.exports